import React from 'react';

// Elenco "Servizi inclusi" di un tipo di assistenza (tariffario), condiviso tra la pagina
// operatore e il portale cliente, così le due viste mostrano le voci allo stesso modo:
// "Tecnico specializzato: € 60+iva".
// compact: versione ridotta per il riquadro "Riepilogo Richiesta".

// Ordine dei tipi di assistenza uguale in tutte le pagine: dalla priorità più bassa
// all'urgenza (priorityValue più alto = più tempo per intervenire)
export const sortAssistanceTypes = (types) =>
  (Array.isArray(types) ? types.slice() : []).sort(
    (a, b) => (b?.priority?.priorityValue ?? 0) - (a?.priority?.priorityValue ?? 0)
  );

const normalizeElement = (el) => {
  if (typeof el === 'string') return { voce: '', importo: el };
  if (!el || typeof el !== 'object') return null;
  const voce = el.title || '';
  let importo = el.label || '';
  // Il campo numerico value e' usato solo se manca il testo dell'importo
  if (!importo && el.value) {
    const n = parseFloat(el.value);
    importo = isNaN(n) ? String(el.value) : `${n.toFixed(2).replace('.', ',')} €`;
  }
  if (!voce && !importo) return null;
  return { voce, importo };
};

const groupIcon = (title) => {
  const t = (title || '').toLowerCase();
  if (t.includes('diritto di chiamata')) return { icon: 'fa-phone', color: 'text-green-600' };
  if (t.includes('tariffa oraria') || t.includes('ora')) return { icon: 'fa-clock', color: 'text-orange-500' };
  if (t.includes('chilometrico') || t.includes('km')) return { icon: 'fa-route', color: 'text-purple-500' };
  return { icon: 'fa-circle-check', color: 'text-blue-500' };
};

const AssistanceTypeServices = ({ tipo, compact = false, isMobile = false }) => {
  const items = Array.isArray(tipo?.items) ? tipo.items : [];
  if (items.length === 0) return null;

  const small = compact || isMobile;

  const gruppi = items.map((item) => {
    if (typeof item === 'string') return { title: item, elements: [] };
    const raw = item?.elements
      ? (Array.isArray(item.elements) ? item.elements : Object.values(item.elements))
      : [];
    return { title: item?.title || '', elements: raw.map(normalizeElement).filter(Boolean) };
  });

  return (
    <div
      className={
        compact
          ? 'mt-2 pt-2 border-t border-blue-100'
          : isMobile
            ? 'ml-5 mt-2 bg-gray-50 p-2.5 rounded border border-gray-100'
            : 'ml-7 mt-3 bg-gray-50 p-4 rounded-md border border-gray-100'
      }
    >
      <h4 className={`font-medium flex items-center border-b border-gray-200 ${small ? 'text-xs mb-2 pb-1' : 'text-sm mb-3 pb-2'}`}>
        <i className={`fa-solid fa-list-check text-blue-500 ${small ? 'mr-1' : 'mr-2'}`}></i>
        Servizi inclusi
      </h4>
      <div className={small ? 'space-y-1.5' : 'space-y-3'}>
        {gruppi.map((gruppo, index) => {
          const { icon, color } = groupIcon(gruppo.title);
          return (
            <div
              key={index}
              className={`flex items-start border-b border-gray-100 last:border-b-0 last:pb-0 ${small ? 'pb-1.5' : 'pb-3'}`}
            >
              <div className={`${color} mt-1 flex-shrink-0 ${small ? 'mr-2 text-xs' : 'mr-3'}`}>
                <i className={`fa-solid ${icon}`}></i>
              </div>
              <div className="flex-grow">
                {gruppo.title && (
                  <p className={`font-medium text-gray-800 ${small ? 'text-xs' : 'text-sm'}`}>{gruppo.title}</p>
                )}
                {gruppo.elements.length > 0 && (
                  <ul className={small ? 'mt-1 space-y-1' : 'mt-2 space-y-2'}>
                    {gruppo.elements.map((el, idx) => (
                      <li key={idx} className={`text-gray-600 flex items-start ${small ? 'text-xs' : 'text-sm'}`}>
                        <span className={`text-green-500 flex-shrink-0 mt-0.5 ${small ? 'mr-1' : 'mr-2 text-xs'}`}>
                          <i className="fa-solid fa-euro-sign"></i>
                        </span>
                        <span>
                          {el.voce && <span className="font-medium text-gray-700">{el.voce}{el.importo ? ':' : ''} </span>}
                          {el.importo}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AssistanceTypeServices;
